export default {
  functionKey: "GRANDE.VALEUR",
  title: "GRANDE.VALEUR",
  group: "Calcul",
  origin: [],
  target: [],
  targetRequired: true,
  multiOrigin: true,
  arguments: [],
  maxArguments: 1,
  requiredArguments: [{ argumentKey: "N", name: "Rang" }],
  expectedArguments: [
    { name: "Rang", argumentKey: "N", single: true, initialValue: "1" }
  ],
  description: "Retourne la Nième plus grande valeur parmi plusieurs colonnes. Ajoutez les colonnes en Origine, le rang en Argument (1 = max).",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol, allOrigins = []) {
    const cols = allOrigins.length > 0 ? allOrigins : (origin ? [origin] : []);
    const n = args[0] || '1';
    if (cols.length === 0) return { displayCode: '', safeCode: '' };
    const safeCode = `var _gv=[${cols.join(',')}].map(function(v){return parseFloat(v);}).filter(function(v){return !isNaN(v);}).sort(function(a,b){return b-a;}); ${destination}=_gv.length>=(${n})?String(_gv[(${n})-1]):'';`;
    return { displayCode: safeCode, safeCode };
  }
}
